define('models/modals/messenger/index',['require','models/base/model','models/base/modal','models/base/sync-collection','models/base/widget','mediator'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        ModalModel = require('models/base/modal'),
        SyncCollection = require('models/base/sync-collection'),
        Widget = require('models/base/widget');

    var MessageItem = Model.extend({
        urlPath: '/modal/messenger/message',
        defaults: {
            selected: false
        }
    });

    var MessagesItemCollection = SyncCollection.extend({
        model: MessageItem
    });

    var MessengerModalContent = Widget.extend({
        action: 'message.list',
        collectionClass: {
            messages: MessagesItemCollection
        },
        defaults: {
        },
        urlParams: function() {
            var params = Widget.prototype.urlParams.apply(this, arguments);
            params.curatorUserId = this.get('id');
            params.lastMessageId = this.get('lastMessageId');
            return params;
        },
        parse: function(data) {
            if (data && data.messages && data.messages.length) {
                this.set('lastMessageId', data.messages[data.messages.length-1].id);
            }
            return Widget.prototype.parse.apply(this, arguments);
        },
        parseSubCollection: function(coll, name, data) {
            var input = data[name];
            if (input) {
                coll.add(input);
            }
        }
    });

    var MessengerModalModel = ModalModel.extend({
        defaults: {
            'title': 'Персональный менеджер',
            'buttons': [
                { caption: 'Отправить', className: 'btn-success', 'action': 'send' }
            ],
            body: ''
        },
        constructor: function() {
            ModalModel.apply(this, arguments);
            this.content = new MessengerModalContent(this.get('manager'));
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.content.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        },
        sendMessage: function(message) {
            var mediator = require('mediator');

            this.content.messages.add({
                message: message,
                curatorUserId: this.content.get('id'),
                senderName: mediator.user.get('fio'),
                sendDate: new Date()
            }).save();
        }
    });

    return MessengerModalModel;
});
